import React from 'react';
import { BLOCKS } from '@contentful/rich-text-types';

import RichText from '../../UI/RichText';
import Image from '../../UI/Image/Image';
import Seo from '../../Seo/Seo';
import {
  ContentfulPage,
} from '../../../ContentfulTypes';
import {
  Container,
  ContentLeft,
  ContentRight,
  ContentWrapper,
  Headline,
  Link404,
} from './styles';

interface Props {
  contentfulData: ContentfulPage;
}

const headlineOptions = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => children,
  },
};

const bodyOptions = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => <p>{children}</p>,
  },
};

const NotFoundScreen = ({ contentfulData }: Props) => (
  <Container>
    <Seo
      title={contentfulData?.metaTitle}
      description={contentfulData?.metaDescription?.metaDescription}
      noIndex
    />
    <ContentLeft>
      <ContentWrapper>
        <Headline>
          <RichText
            document={contentfulData?.pageSections[0]?.imageDescription?.heading}
            options={headlineOptions}
          />
        </Headline>
        <Headline className="secondary">
          <RichText
            document={contentfulData?.pageSections[0]?.imageDescription?.subHeading}
            options={headlineOptions}
          />
        </Headline>
        <Link404>
          <RichText
            document={contentfulData?.pageSections[0]?.imageDescription?.contentBody}
            options={bodyOptions}
          />
        </Link404>
      </ContentWrapper>
    </ContentLeft>
    <ContentRight
      style={{
        backgroundImage: `url(${contentfulData?.pageSections[0]?.backgroundImageDesktop?.asset?.localImage?.publicURL})`,
      }}
    >
      <Image
        image={contentfulData?.pageSections[0]?.foregroundImageDesktop}
        isImageDecorative
      />
    </ContentRight>
  </Container>
);

export default NotFoundScreen;
